export const MINIMUM_LINE_ITEM_SELECTION = 1;
export const MAXIMUM_LINE_ITEM_SELECTION = 20;
export const SELECT_LINE_ITEM_ERROR = 'Select line item';

export const MAXIMUM_LINE_ITEM_SELECTION_ERROR = `You can include a maximum of ${MAXIMUM_LINE_ITEM_SELECTION} line items in a report.`;
